import Container from '../lib/gui/dom/Container';
import { EPGUtil } from './EPGUtil';
import DataList from './DataList';
import Grid from './../lib/gui/components/Grid';
import GridRow from './../lib/gui/components/GridRow';
import GridItem from './../lib/gui/components/GridItem';
import EpgConstants from './EpgConstants';
import TimeIndicatorController from './TimeIndicatorController';
import Utils from '../../utils/Utils';
import settings from '../../devices/all/settings';
import { recordFullObserver } from '../../components/PersistentMiniEpg/MiniObserver';
import { NpvrUtil } from '../Npvr/NpvrUtil';
import EpgPersistence from './EpgPersistence';
import logger from 'src/utils/logger/logger';

export default class EventGridController {
    /**
     * El controller top de este controller
     */
    eventController;

    constructor(parentController) {
        this.eventController = parentController;
        this.gridContainer = null;
        this.verticalSpaceBetweenRows = EpgConstants.VERTICAL_SPACE_BETWEEN_ROWS;
        // La lista actual de eventos por canal
        this.dataList = new DataList();

        // La lista actual de canales
        this.currentChannels = null;
        this.drawing = false;
        this.initialised = false;
        this.rows = [];

        // Bind some methods
        this.drawCallback = this.drawCallback.bind(this);
        this.diffGids = this.diffGids.bind(this);
        this.getIndexOf = this.getIndexOf.bind(this);
        this.draw = this.draw.bind(this);
        this.updateGrid = this.updateGrid.bind(this);
        this.reDrawRecordIcon = this.reDrawRecordIcon.bind(this);
        this.getlastDirection = this.getlastDirection.bind(this);

        this.onFocusedEventCallback = null;
        this.onClicEventCallback = null;
        this.onRecordEventCallback = null;

        this.previousWindowTime = {
            startTime: null,
            endTime: null
        };

        this.currentFocused = {
            row: null,
            item: null
        };

        this.isNowEvent = false;
        this.focusedEventDateBegin = null;
        this._now = Utils.nowAsTimestampSeconds();
        this.intervalGridUpdate = null;
        this.currentEventInFocus = null;
        this.sameCurrentTimeWindow = false;
        this.lastDirection =  null;
    }

    /**
     *
     * @param {*} DOMWrapper el container de este elemento
     */
    initialise(DOMWrapper) {
        if (this.initialised)
            return;

        const defaultRowHeight = EpgConstants.VERTICAL_ROW_HEIGHT;
        this.gridContainer = new Grid(DOMWrapper, { className: 'event-list-grid', id: 'eventListGrid' });
        // Load event rows
        const numberRows = this.eventController.getRowsPerGrid();
        let rowTopOffset = 0; // Acumulador offset
        for (let i = 0, len = numberRows; i < len; i++) {
            // Generamos los rows y se los pegamos al Grid en el DOM
            const {channelList = null} = this.eventController;
            let unRow = new GridRow(this.gridContainer, { className: 'event-list-row' }, channelList, i);
            let rowHeight = defaultRowHeight;
            let rowStyle = {
                height: rowHeight + 'px',
                position: 'absolute',
                width: '100%',
                overflow: 'hidden'
            };
            unRow.setLeft(0);
            unRow.setTop(rowTopOffset);
            unRow.setGetDirection(this.getlastDirection);
            //rowStyle.backgroundColor = 'cyan';
            unRow.setStyle(rowStyle);
            // Add style, next row
            rowTopOffset = rowTopOffset + this.verticalSpaceBetweenRows + rowHeight;
            this.rows.push(unRow);
        }
        this.timeIndicator = new TimeIndicatorController(this, this.gridContainer);
        this.initialised = true;
        recordFullObserver.subscribe(this.reDrawRecordIcon);
    }

    setClickedEventCallback(cbk) {
        this.onClicEventCallback = cbk;
    }
    setRecordEventCallback(cbk) {
      this.onRecordEventCallback = cbk;
    }

    setFocusedEventCallback(cbk) {
        this.onFocusedEventCallback = cbk;
    }

    onFocusedEvent(event) {
        if (this.onFocusedEventCallback) {
            this.isNowEvent = this.setIsNowEvent(event);
            this.onFocusedEventCallback(event);
        }
    }

    setIsNowEvent(event) {
        return this.eventController.eventIsCurrent(event);
    }


    setLoading(type) {
        const actions = EpgConstants.ACTIONS_LOADING;
        switch(type) {
            case actions.OPACITY:
                this.setOpacity(EpgConstants.OPACITY_GRID);
                break;
            case actions.NONE:
                this.setWithoutStyle();
                break;
            default:
                break;
        }

    }

    setWithoutStyle(){
        // Aui deberia de ir vali
        this.gridContainer.setStyle({opacity: EpgConstants.WITHOUT_OPACITY});
    }

    setOpacity(opacity) {
        this.gridContainer.setStyle({ opacity: opacity });
    }

    show() {
        this.gridContainer.show();
    }

    hide() {
        this.gridContainer.hide();
    }

    getEndTime() {
        return this.eventController.getEndTime();
    }

    isInCurrentWindow(time) {
        return (time >= this.eventController.getStartTime() && time < this.eventController.getEndTime());
    }

    isEventInCurrentWindow(event) {
        return this.isInCurrentWindow(event.date_begin) || this.isInCurrentWindow(event.date_end);
    }

    // Para encontrar el time
    floorTimeToHalfHour(time) {
        return this.eventController.floorTimeToHalfHour(time);
    }

    floorTimeToWindowSize(time) {
        return this.eventController.floorTimeToWindowSize(time);
    }

    getStartTime() {
        return this.eventController.getStartTime();
    }

    getTimeWindowLength() {
        return this.eventController.getTimeWindowLength();
    }

    /**
     *
     * @param {*} groupIds array de group ids a pintar
     * @param {*} startTime starttime en segundos
     * @param {*} endTime endtime en segundos
     * @param {*} keyDirection la dirección del RC que generó el draw (ahora sólo se activa con left o right):
     *                         null | EpgConstants.GRIDEVENT_LEFT_NAVIGATION | EpgConstants.GRIDEVENT_RIGHT_NAVIGATION
     *
     * NO invoques este método directamente, llámalo a través
     * de EventController para poder controlar la bandera de "isDrawing"
     */
    draw(groupIds, startTime, endTime, keyDirection) {

        // window.GLOBAL_DRAW_TIME = window.performance.now();

        // Tengo la misma a ventana ?
        logger.debug('[NEPG] EVENTGRID DIFF startTime, endTime,this.previousWindowTime ', startTime, endTime, this.previousWindowTime);
        const sameCurrentTimeWindow = startTime === this.previousWindowTime.startTime && endTime === this.previousWindowTime.endTime;
        this.sameCurrentTimeWindow = sameCurrentTimeWindow;
        logger.debug('[NEPG] EVENTGRID DIFF sameCurrentTimeWindow: ' + (sameCurrentTimeWindow ? 'TRUE' : 'FALSE'));

        this.focusedEventDateBegin = startTime;

        this.previousWindowTime = {
            startTime: startTime,
            endTime: endTime
        };
        let onlySomeGids = false;
        let _groupIds = groupIds.slice(0);

        let gidDiff = [];
        if (sameCurrentTimeWindow) {
            if (this.currentChannels && Array.isArray(groupIds) && groupIds.length > 0) {
                //gidRemain = this.diffGids(groupIds, this.currentChannels);
                // Obtener sólo los ids que falten
                gidDiff = this.diffGids(this.currentChannels, groupIds);
                if (Array.isArray(gidDiff) && gidDiff.length > 0 && gidDiff.length < groupIds.length) {
                    _groupIds = gidDiff;
                    onlySomeGids = true;
                }
            }
        }

        logger.debug('[NEPG] EVENTGRID SENT EVENTS > ', _groupIds, new Date(startTime * 1000), new Date(endTime * 1000));
        // window.NEPG_GETDATA = window.performance.now();

        const drawGridCallback = (events) => {
            if (sameCurrentTimeWindow && onlySomeGids) {
                // Merge results, currentevents es el array de eventos actuales en el grid
                // Que corresponde a this.currentChannels
                let currentEvents = this.dataList.getData().slice(0);
                let nextEvents = [];

                // window.NEPG_UNOAUNO = window.performance.now();
                let recycleEvents = new Map();
                for (let y = 0, len = groupIds.length; y < len; y++) {
                    //  Si está en el diff, se traen los eventos del result
                    let idxDiff = this.getIndexOf(groupIds[y], gidDiff);
                    if (idxDiff !== -1) {
                        nextEvents[y] = events[idxDiff];
                    }
                    else {
                        let idxCurrent = this.getIndexOf(groupIds[y], this.currentChannels);
                        if (idxCurrent !== -1) {
                            nextEvents[y] = currentEvents[idxCurrent];
                            let previousItems = this.rows[idxCurrent].getItems().slice(0);
                            recycleEvents.set(groupIds[y], {
                                moveFrom: idxCurrent,
                                moveTo: y,
                                items: previousItems,
                                events: currentEvents[idxCurrent].slice(0)
                            });
                        }
                    }
                    // To protect
                    if (typeof nextEvents[y] === 'undefined') {
                        nextEvents[y] = [];
                    }
                    // Si no esta en el diff, se traen de los currentevents
                }
                // console.log('[NEPG] EVENTGRID TIMEMARK UNO A UNO CALC: ' + (window.performance.now() - window.NEPG_UNOAUNO));
                this.drawCallback(nextEvents, groupIds, recycleEvents, keyDirection);
            }
            else {
                this.drawCallback(events, groupIds, null, keyDirection);
                logger.debug('[NEPG] EVENTGRID DIFF NO DIF  gruoupIds ', groupIds);
            }
            this.currentChannels = groupIds;
        };

        logger.debug('[NEPGPERF] QUERY de ' + _groupIds.length + ' canales');
        //this._now = Date.now() / 1000;
        this._now = Utils.nowAsTimestampSeconds();
        EPGUtil.getGroupIdsEventsByTimeWindow(_groupIds, startTime, endTime, drawGridCallback);
    }

    /**
     *
     * @param {*} events los eventos, en array
     * @param {*} groupIds los group id a pintar
     * @param {*} recycleEvents hay eventos que se puedan reciclar? para no recalcularlos en pantalla (performance)
     * @param {*} keyDirection la dirección del RC que generó el draw (ahora sólo se usa con left o right):
     *                         null | EpgConstants.GRIDEVENT_LEFT_NAVIGATION | EpgConstants.GRIDEVENT_RIGHT_NAVIGATION
     */
    drawCallback(events, groupIds, recycleEvents, keyDirection) {
        // console.log('[NEPGPERF] query time: ' + (window.performance.now() - window.NEPG_GETDATA));

        //const previousEvents = this.dataList.getData();
        this.dataList.clear();
        this.dataList.loadData(events);

        const defaultRowWidth = EpgConstants.ROW_WIDTH;
        // window.NEPG_BUILDGRID = window.performance.now();

        // Tiene eventos que se debe reciclar?
        let hasRecycled = recycleEvents && recycleEvents.size > 0;

        // Antes de pintar, destruir items de rows/canales que saldrán de la vista/grid
        if(hasRecycled) {
            // El group id desaparece del grid?
            for(let y = 0, len = this.currentChannels.length; y < len; y++) {
                if(this.getIndexOf(this.currentChannels[y], groupIds) === -1) {
                    this.rows[y].destroy();
                }
            }
        }

        for (let j = this.rows.length; j--;) {
            let recycled = null;
            if(hasRecycled) {
                if(recycleEvents.has(groupIds[j])) {
                    recycled = recycleEvents.get(groupIds[j]);
                }
            }
            // window.NEPG_BUILDGRID_PER_ROW = window.performance.now();
            let eventsForRow = this.dataList.getRowAtIndex(j + 1);
            let unRow = this.rows[j];
            unRow.setData(eventsForRow);
            unRow.setTimeWindowStart(this.getStartTime());
            unRow.setTimeWindowEnd(this.getEndTime());
            unRow.setTimeWindowLength(this.getTimeWindowLength());
            unRow.setGridWidth(defaultRowWidth);

            if(hasRecycled) {
                unRow.empty();
                if(recycled) {
                    unRow.setCacheItems(recycled.items);
                }
                else {
                    unRow.setCacheItems([]);
                }
            }
            else {
                unRow.setCacheItems([]);
            }

            // Settear el tiempo de la ventana
            unRow.draw();
            // console.log('[NEPGPERF] ROW BUILD TOTAL PER ROW #' + (j + 1) + ': ' + (window.performance.now() - window.NEPG_BUILDGRID_PER_ROW));
        }
        // console.log('[NEPGPERF] BUILD ONLY GRID: ' + (window.performance.now() - window.NEPG_BUILDGRID));
        this.timeIndicator.updatePosition(this._now);

        this.setLoading(EpgConstants.ACTIONS_LOADING.NONE);
        this.focusAfterDrawing(keyDirection);
        this.startGridUpdateInterval();

        if (settings.enable_epg_syc) {
            this.eventController.paintChannels(groupIds);
        }

        this.eventController.setGridDrawing(false);

        // if (window.GLOBAL_DRAW_TIME)
        //     console.log('[NEPGPERF] GLOBAL_DRAW_TIME: ' + (window.performance.now() - window.GLOBAL_DRAW_TIME + 'ms'));
    }

    focusAfterDrawing(keyDirection) {
        // Quitar foco anterior si existe
        if (this.currentFocused.row && this.currentFocused.item) {
            if (typeof this.rows[this.currentFocused.row] !== 'undefined') {
                if (typeof this.rows[this.currentFocused.row].items[this.currentFocused.item] !== 'undefined') {
                    this.rows[this.currentFocused.row].items[this.currentFocused.item].hightlightOff();
                }
            }
        }

        const idx_row = this.eventController.getCurrentChannelIndex();
        let idx_item = 0;
        if(Utils.isNotNullOrNotUndefined(keyDirection)) {
            if(keyDirection === EpgConstants.GRIDEVENT_LEFT_NAVIGATION) {
                let eventsForRow = this.dataList.getRowAtIndex(idx_row + 1);
                if(eventsForRow) {
                    let itemsCount = eventsForRow.length;
                    if(!this.eventController.hasLeftNavigation() && (this.sameCurrentTimeWindow)){
                        idx_item = 0;
                    }
                    else {
                        idx_item = itemsCount > 0 ? itemsCount - 1 : 0;
                    }
                    if(eventsForRow[idx_item] && eventsForRow[idx_item].date_begin) {
                        this.focusedEventDateBegin = Math.max(eventsForRow[idx_item].date_begin, this.getStartTime());
                    }
                }
            }
        }

        this.focusOn(idx_row, idx_item);
        logger.debug('[NEPG] keyHandler EventGridController focus, idx_row: ' + idx_row + ', idx_item: ' + idx_item);
    }

    diffGids(actual, siguiente) {
        return siguiente.filter(i => actual.indexOf(i) < 0);
    }

    /**
     *
     * @param {*} item element is supposed is in
     * @param {*} items plain array
     */
    getIndexOf(item, inItems) {
        return inItems.findIndex(unitem => item === unitem);
    }

    updateCurrentFocused(idx_row, idx_item) {
        this.currentFocused.row = idx_row;
        this.currentFocused.item = idx_item;
    }

    focusOff(idx_row, idx_item) {
        if (isNaN(idx_row)) return;
        if (isNaN(idx_item)) return;
        if (typeof this.rows[idx_row] !== 'undefined') {
            if (typeof this.rows[idx_row].items[idx_item] !== 'undefined') {
                this.rows[idx_row].items[idx_item].hightlightOff();
            }
        }
    }

    focusOn(idx_row, idx_item) {
        if (isNaN(idx_row)) return;
        if (isNaN(idx_item)) return;
        if (typeof this.rows[idx_row] !== 'undefined') {
            if (typeof this.rows[idx_row].items[idx_item] !== 'undefined') {
                this.rows[idx_row].items[idx_item].hightlightOn();
                const focusedEvent = this.rows[idx_row].getDataItemAtIndex(idx_item);
                this.isNowEvent = this.setIsNowEvent(focusedEvent);
                this.currentEventInFocus = focusedEvent;
                this.updateCurrentFocused(idx_row, idx_item);
                this.onFocusedEvent(this.rows[idx_row].getDataItemAtIndex(idx_item));
            }
        }
    }

    getCurrentFocusedRow() {
        return this.currentFocused.row;
    }

    getCurrentFocusedItem() {
        return this.currentFocused.item;
    }

    handleClick() {
        if (this.onClicEventCallback) {
            if (Utils.isNullOrUndefined(this.rows[this.currentFocused.row])) return;
            if (Utils.isNullOrUndefined(this.currentFocused.item)) return;
            let focusedEvent = this.rows[this.currentFocused.row].getDataItemAtIndex(this.currentFocused.item);
            if(!focusedEvent &&
                Array.isArray(this.currentChannels) &&
                this.currentChannels[this.currentFocused.row]
            ){
                focusedEvent = {
                    group_id : this.currentChannels[this.currentFocused.row],
                    date_begin: Utils.nowAsTimestampSeconds(),
                    date_end: Utils.nowAsTimestampSeconds(),
                }
            }
            this.onClicEventCallback(focusedEvent);
        }
    }

    async handleStepRight() {
        if(this.eventController.isGridDrawing()) {
            return;
        }

        if (await this.eventController.updateGridTime(EpgConstants.GRIDEVENT_RIGHT_NAVIGATION)) {
            // this.setLoading(EpgConstants.OPACITY_GRID);
            this.eventController.drawGrid(this.currentChannels, this.getStartTime(), this.getEndTime(), EpgConstants.GRIDEVENT_RIGHT_NAVIGATION)
            this.eventController.moveStepRightSchedule();
            this.timeIndicator.updatePosition(this._now);
        }
    }

    async handleStepLeft() {

        if(this.eventController.isGridDrawing()) {
            return;
        }

        if (await this.eventController.updateGridTime(EpgConstants.GRIDEVENT_LEFT_NAVIGATION)) {
            // this.setLoading(EpgConstants.OPACITY_GRID);
            this.eventController.drawGrid(this.currentChannels, this.getStartTime(), this.getEndTime(), EpgConstants.GRIDEVENT_LEFT_NAVIGATION)
            this.eventController.moveStepLeftSchedule();
            this.timeIndicator.updatePosition(this._now);
        }
    }

    getlastDirection () {
        return this.lastDirection;
    }

    enableUp = () =>{
        if(this.eventController && this.eventController.channelList && this.eventController.channelList.list && Array.isArray(this.eventController.channelList.list)){
            if(this.currentFocused && typeof this.currentFocused == 'object'){
                const { row = 0} = this.currentFocused;
                if(row == 0 && this.eventController.channelList.list.length <= EpgConstants.TOTAL_ROWS_CHANNEL_GRID){
                    return true;
                }
            }
        }
        return false;
    }

    enableDown = () =>{
        if(this.eventController && this.eventController.channelList && this.eventController.channelList.list && Array.isArray(this.eventController.channelList.list)){
            if(this.currentFocused && typeof this.currentFocused == 'object'){
                const { row = 0} = this.currentFocused;
                if(row == this.eventController.channelList.list.length - 1 && this.eventController.channelList.list.length <= EpgConstants.TOTAL_ROWS_CHANNEL_GRID){
                    return true;
                }
            }
        }
        return false;
    }

    keyHandler(keyName, event, repeats) {
        let resp = true;
        //this._now = Date.now() / 1000;
        this._now = Utils.nowAsTimestampSeconds();
        if (keyName == 'OK' && !repeats) {
            // Mandamos a playear, va?
            this.handleClick();
        }
        else if (keyName == 'RIGHT' && !repeats) {
            this.lastDirection = keyName;
            // Me muevo a página? o sólo un renglón abajo?
            if (!isNaN(this.currentFocused.row)) {
                const currentRowLength = this.rows[this.currentFocused.row].items.length;
                if (currentRowLength === (this.currentFocused.item + 1)) {
                    // Navegación a la derecha, uno a uno
                    this.handleStepRight();
                }
                else {
                    let focusedEvent = this.rows[this.currentFocused.row].getDataItemAtIndex(this.currentFocused.item + 1);
                    if (focusedEvent && focusedEvent.date_begin) {
                        this.focusedEventDateBegin = Math.max(focusedEvent.date_begin, this.getStartTime());
                    }
                    this.focusOff(this.currentFocused.row, this.currentFocused.item);
                    this.focusOn(this.currentFocused.row, this.currentFocused.item + 1);
                }
            }
        }
        else if (keyName == 'LEFT' && !repeats) {
            this.lastDirection = keyName;
            if (!isNaN(this.currentFocused.row)) {
                if (this.currentFocused.item === 0) {
                    this.handleStepLeft();
                }
                else {
                    let focusedEvent = this.rows[this.currentFocused.row].getDataItemAtIndex(this.currentFocused.item - 1);
                    if (focusedEvent && focusedEvent.date_begin) {
                        this.focusedEventDateBegin = Math.max(focusedEvent.date_begin, this.getStartTime());
                    }
                    this.focusOff(this.currentFocused.row, this.currentFocused.item);
                    this.focusOn(this.currentFocused.row, this.currentFocused.item - 1);
                }
            }
        }
        else if (keyName == 'DOWN' && !repeats) {
            if(this.enableDown()) return;
            this.lastDirection = '';
            if (EpgConstants.TOTAL_ROWS_CHANNEL_GRID !== (this.currentFocused.row + 1)) {
                this.focusOff(this.currentFocused.row, this.currentFocused.item);

                let idx_event = this.getNextEventToFocusByTime(this.rows[this.currentFocused.row + 1]);
                this.focusOn(this.currentFocused.row + 1, idx_event);
            }
            this.eventController.eventDown(repeats);
        }
        else if (keyName == 'UP' && !repeats) {
            if(this.enableUp()) return;
            this.lastDirection = '';
            if (this.currentFocused.row !== 0) {
                this.focusOff(this.currentFocused.row, this.currentFocused.item);

                let idx_event = this.getNextEventToFocusByTime(this.rows[this.currentFocused.row - 1]);
                this.focusOn(this.currentFocused.row - 1, idx_event);
            }
            this.eventController.eventUp(repeats);
        } else if (keyName == 'REC' && !repeats) {
          this.handleRec();
        } else {
            resp = false;
        }

        return resp;
    }

    async handleRec() {

      if (Utils.isNullOrUndefined(this.rows[this.currentFocused.row])) return;
      if (Utils.isNullOrUndefined(this.currentFocused.item)) return;
      let focusedEvent = this.rows[this.currentFocused.row].getDataItemAtIndex(
        this.currentFocused.item
      );
      if (Array.isArray(this.currentChannels) && this.currentChannels[this.currentFocused.row]) {
        const gID = this.currentChannels[this.currentFocused.row];
        let event = {};

        if (EpgPersistence.isDatabaseDataSource()) {
            event = await EPGUtil.getEventByEventId(focusedEvent.id_composite, focusedEvent.id, gID);
        }else{
            event = focusedEvent;
        }
        if (this.onRecordEventCallback && typeof this.onRecordEventCallback == 'function') {
          this.onRecordEventCallback(event);
        }
      }
    }

    reDrawRecordIcon(eventObserver) {
      if(eventObserver && Array.isArray(eventObserver) && eventObserver.length > 0){
        // LOGICA DE SERIES
        for(const evt  in eventObserver){
            const evtObs = eventObserver[evt];
            this.changeIconOpenFull(evtObs)
        }
      }else{
        // SE MANTIENE LOGICA ANTERIOR
        this.changeIconOpenFull(eventObserver)
      }
    }

    changeIconOpenFull(eventObserver) {
        if(!eventObserver || !(typeof eventObserver  === 'object')) return;
        const rows = this.rows;
        let globalEvent = null;
        const event_fire = eventObserver;
        rows && Array.isArray(rows) && rows.map(row => {
            const row_a = row && row.items;
            row_a &&
            Array.isArray(row_a) &&
            row_a.map(event_s => {
                if (
                event_fire &&
                event_fire.id &&
                event_s.data &&
                event_s.data.id &&
                event_s.data.id == event_fire.id) {
                    globalEvent = event_s;
                    return;
                }
            });
        });
        if (globalEvent && globalEvent.recordImage && globalEvent.recordImage.rootElement && globalEvent.recordText &&  globalEvent.recordText.rootElement) {
            const ele = globalEvent.recordImage.rootElement;
            const eleText = globalEvent.recordText.rootElement;
            const datNpvr = NpvrUtil.getRecordingAsset(event_fire.recording_status);
            if (ele && ele.src) ele.src = datNpvr && datNpvr.imageSrc || '';
            if (eleText){
                eleText.innerText = datNpvr && datNpvr.label || '';
            }
        }
    }

    getNextEventToFocusByTime(nextRow) {
        if (!nextRow) return 0;
        //this._now = Date.now() / 1000;
        this._now = Utils.nowAsTimestampSeconds();
        let rowItems = nextRow.getData();
        let rowLength = Array.isArray(rowItems) ? rowItems.length : 0;
        for (let i = 0, len = rowLength; i < len; i++) {
            if (rowItems[i].date_end > this.focusedEventDateBegin) {
                return i;
            }
            if ((this.focusedEventDateBegin <= this._now)
                && (this.getStartTime() + (EpgConstants.TIMELINE_CELL_SIZE_MS / 1000) >= this._now)
                && this.isNowEvent
                && rowItems[i].date_end >= this._now) {
                return i;
            }
        }

        return 0;
    }

    updateGrid() {
        //this._now = Date.now() / 1000;
        this._now = Utils.nowAsTimestampSeconds();
        if (this.isInCurrentWindow(this._now)) {
            if (this._now > this.getStartTime() + (EpgConstants.TIMELINE_CELL_SIZE_MS / 1000)) {
                // FIXME. Aquí actualizar  el grid ¿?¿?¿? esta funcionalidad
                // no existe en el grid actual/productivo.
            }
            else {
                this.timeIndicator.updatePosition(this._now);
            }
        }
    }

    deactivate() {
        if (this.intervalGridUpdate) clearInterval(this.intervalGridUpdate);
        recordFullObserver.unsubscribe(this.reDrawRecordIcon);
    }

    startGridUpdateInterval() {
        if (this.intervalGridUpdate) clearInterval(this.intervalGridUpdate);
        this.intervalGridUpdate = setInterval(this.updateGrid, EpgConstants.INTERVAL_GRID_UPDATE_MS);
    }
}



// WEBPACK FOOTER //
// ./src/AAF/Nepg/EventGridController.js